<template>
  <base-page-layout title="Consultar benefícios">
    <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
    <div class="d-flex flex-column justify-center align-center my-2 mx-4">
      <span class="gray-title mb-2">Pontos</span>
      <span class="gray-subtitle mx-3">Entre com os dados para identificar o consumidor e o período que deseja consultar.</span>

      <form class="d-flex flex-column mt-6 responsive-width">
        <label class="cinza-0-text">Documento consumidor:</label>
        <v-text-field
          v-model="consumer"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          :error-messages="consumerErrors"
          placeholder="CPF ou CNPJ"
          required
          outlined
          background-color="white"
          :disabled="loading"
          append-icon="search"
          @keydown.enter="submit"
          @input="$v.consumer.$touch()"
          @blur="$v.consumer.$touch()"
        />
        <mf-button
          class="align-self-center"
          size="md"
          :loading="loading"
          :disabled="loading || disabledSubmit"
          color="marca-0-l40"
          label="Buscar"
          icon="arrow_forward"
          icon-position="right"
          @click="submit"
        />
      </form>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import { QUERY_USER_ACTIVE_PRODUCT_VOUCHER } from '../../graphql'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    loading: false,
    consumer: '',
  }),
  computed: {
    consumerErrors() {
      const errors = []
      if (!this.$v.consumer.$dirty) return errors
      !this.$v.consumer.required && errors.push('Preencha o campo com CPF ou CNPJ')
      !this.$v.consumer.minLength && errors.push('CPF ou CNPJ inválido')
      return errors
    },
    disabledSubmit() {
      return this.$v.$invalid
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'consultar-ofertas' })
    },
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.loading = true
      try {
        const result = await this.$apollo.query({
          query: QUERY_USER_ACTIVE_PRODUCT_VOUCHER,
          fetchPolicy: 'no-cache',
          variables: {
            documentNo: this.onlyNumbers(this.consumer),
          },
        })
        const userData = result.data.userActiveProductVoucher
        if (userData && userData.userInfo) {
          this.goToResults(userData.userInfo, userData.activeVoucher)
        } else {
          this.$snackbar({ message: 'Vale-troca ativo não encontrado', snackbarColor: 'warning' })
        }
      } catch (err) {
        console.log(err)
        this.$snackbar({ message: 'Erro ao buscar consumidor', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    onlyNumbers(string) {
      return string.replace(/\D/g, '')
    },
    goToResults(userInfo, activeVoucher) {
      const params = {
        c: userInfo,
      }

      if (activeVoucher) {
        params.v = activeVoucher
      }

      this.$router.push({
        name: 'consultar-pontos-resultado',
        params,
      })
    },
  },
  validations: {
    consumer: { required, minLength: minLength(11) },
  },
}
</script>

<style lang="scss" scoped>
.gray-title {
  color: $cinza-d20;
  font-size: 22px;
  line-height: 120%;
  font-weight: 700;
}

.gray-subtitle {
  color: $cinza-d10;
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.4px;
}

.cinza-0-text {
  color: $cinza-0;
}

.responsive-width {
  width: 40%;
}

@media screen and (max-width: 933px) {
  .responsive-width {
    width: 100%;
  }
}
</style>
